<template lang="pug">
span.color-indicator(:style="style")
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true,
    },
    borderRadius: String,
    size: String,
  },
  computed: {
    style() {
      let output = { background: this.color }
      if (this.borderRadius) output.borderRadius = this.borderRadius
      if (this.size) {
        output.width = this.size
        output.height = this.size
      }
      return output
    },
  },
}
</script>

<style scoped lang="stylus">
color-indicator-size = 24px;
.color-indicator
  display inline-block
  border-radius 50%
  width color-indicator-size
  height color-indicator-size
  border 1px solid #ececec
</style>
